import { Svg } from '../svg';
import { IconType } from '../../models';
import { theme } from '../../styles/theme';

export const IconClose: IconType = ({ className = '' }) => (
  <Svg className={className} viewBox="0 0 20 20">
    <line
      x1="0.75"
      y1="-0.75"
      x2="24.3304"
      y2="-0.75"
      transform="matrix(-0.719455 0.694539 -0.719455 -0.694539 18.4531 0.840332)"
      stroke={theme.colors.text}
      strokeWidth="1.5"
      strokeLinecap="round"
      vectorEffect="non-scaling-stroke"
    />
    <line
      x1="0.75"
      y1="-0.75"
      x2="24.3304"
      y2="-0.75"
      transform="matrix(0.719455 0.694539 -0.719455 0.694539 0.463135 1.97119)"
      stroke={theme.colors.text}
      strokeWidth="1.5"
      strokeLinecap="round"
      vectorEffect="non-scaling-stroke"
    />
  </Svg>
);
